var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#CFEBCE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 72,
    height: 72,
    rx: 36,
    stroke: "#CFEBCE",
    strokeOpacity: 0.2,
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0278 38.8564C52.4464 38.8566 56.8491 43.2601 56.8491 48.6787C56.8489 54.0972 52.4463 58.4998 47.0278 58.5C41.6092 58.5 37.2058 54.0973 37.2056 48.6787C37.2056 43.26 41.6091 38.8564 47.0278 38.8564ZM47.0278 44.2334C43.5565 44.2334 40.5503 48.2555 40.4233 48.4248C40.2966 48.5941 40.2965 48.8054 40.4233 48.9746C40.5503 49.1439 43.5988 53.166 47.0278 53.166C50.541 53.1658 53.5038 49.1447 53.6313 48.9746C53.716 48.8054 53.7159 48.5519 53.6313 48.4248C53.5043 48.2555 50.4989 44.2334 47.0698 44.2334H47.0278ZM47.0278 46.0117C48.5006 46.0119 49.6948 47.2059 49.6948 48.6787C49.6946 50.1514 48.5005 51.3455 47.0278 51.3457C45.555 51.3457 44.361 50.1515 44.3608 48.6787C44.3608 47.2057 45.5549 46.0117 47.0278 46.0117ZM40.9741 35.3438C43.7255 35.3438 46.0961 35.8512 47.0698 37.7559H47.0278C41.5246 37.7559 36.9522 41.8624 36.1899 47.1963C35.9359 47.1963 35.6396 47.2393 35.3433 47.2393C28.6122 47.4933 23.1509 44.7412 23.1509 44.7412V39.873C23.1509 36.2325 26.1142 35.3438 29.7124 35.3438C29.7124 35.3438 32.2106 37.1641 35.3433 37.1641C38.5606 37.2064 40.9741 35.3438 40.9741 35.3438ZM35.3433 21.5C38.8146 21.5 41.6089 24.5904 41.6089 28.4004C41.6089 32.2104 38.8146 35.3008 35.3433 35.3008C31.8719 35.3008 29.0776 32.2104 29.0776 28.4004C29.0777 24.5904 31.8719 21.5 35.3433 21.5Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewProfile);
export default __webpack_public_path__ + "static/media/viewProfile.d92fa28bd3efc5f19c54d87e729ff46a.svg";
export { ForwardRef as ReactComponent };